export { Template as EstatePlanningRecommendationQuizQuestionsStepTemplate } from './Template';
